import { type FC } from "react";

import { errorTextContainer } from "../../shared/styles";
import { type TagsValidation } from "../models";

interface TagsErrorMessageProps {
    tagsValidationResult: TagsValidation;
}

export const TagsErrorMessage: FC<TagsErrorMessageProps> = ({ tagsValidationResult }) =>
    tagsValidationResult ? (
        <div data-testid="tags-error" className={errorTextContainer}>
            {tagsValidationResult}
        </div>
    ) : null;
